import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { colors, fonts } from 'bench-style-constants';
const StyledLabel = styled.div<LabelProps>`
  display: flex;
  color: ${colors.dust};
  font-size: 10px;
  font-family: ${fonts.circular};
  font-weight: 300;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.133rem;

  ${props =>
    props.size === 'small' &&
    css`
      font-size: 8px;
      line-height: 8px;
      letter-spacing: 0.1333rem;
    `}

  ${props =>
    props.size === 'large' &&
    css`
      font-size: 12px;
      line-height: 24px;
      font-weight: 600;
      letter-spacing: 0.16rem;
    `}

  ${props =>
    props.size === 'xlarge' &&
    css`
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      letter-spacing: 0.213rem;
    `}

  ${props =>
    props.type === 'dark' &&
    css`
      color: ${colors.charcoal};
    `}
`;
type LabelProps = {
  children: ReactNode;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  type?: 'default' | 'dark';
};

const Label = (props: LabelProps) => <StyledLabel {...props}>{props.children}</StyledLabel>;

Label.defaultProps = {
  size: 'medium',
  type: 'default',
};
export default Label;
